import { bunja } from 'bunja';
import { atom } from 'jotai';
import { atomWithQuery } from 'jotai-tanstack-query';

import { getRestrictedCountriesApi } from '@flipster/apis/v2/countries';

interface SelectedCountry {
  name: string;
  iso2: string;
  image: string;
}

export const restrictedCountryBunja = bunja(() => {
  // 선택된 국가를 저장하는 atom
  const selectedCountryAtom = atom<SelectedCountry | null>(null);

  const restrictedCountriesQueryAtom = atomWithQuery(() => ({
    queryKey: ['getRestrictedCountriesApi'],
    queryFn: () => getRestrictedCountriesApi().then((res) => res.data.restricted),
  }));

  const restrictedCountriesAtom = atom((get) => {
    const query = get(restrictedCountriesQueryAtom);
    return query.data ?? [];
  });

  const isSelectedCountryRestrictedAtom = atom((get) => {
    const selectedCountry = get(selectedCountryAtom);
    const restrictedCountries = get(restrictedCountriesAtom);

    if (!selectedCountry) return false;
    return restrictedCountries.includes(selectedCountry.iso2);
  });

  const setSelectedCountry = atom(null, (get, set, country: SelectedCountry | null) => {
    set(selectedCountryAtom, country);
  });

  const clearSelectedCountry = atom(null, (get, set) => {
    set(selectedCountryAtom, null);
  });

  return {
    selectedCountryAtom,
    restrictedCountriesQueryAtom,
    restrictedCountriesAtom,
    isSelectedCountryRestrictedAtom,
    setSelectedCountry,
    clearSelectedCountry,
  };
});
